module.exports = __webpack_public_path__ + "img/chr_ts_21_5.b1fe41af.png";